import React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
// import { css } from 'styled-components/macro'; //eslint-disable-line
import {
  SectionHeading as HeadingTitle,
  Subheading,
} from 'components/misc/Headings.js';
// import { PrimaryButton as PrimaryButtonBase } from 'components/misc/Buttons.js';
// import { ReactComponent as UserIcon } from 'feather-icons/dist/icons/user.svg';
// import { ReactComponent as TagIcon } from 'feather-icons/dist/icons/tag.svg';
import { ReactComponent as SvgDecoratorBlob1 } from '../../images/svg-decorator-blob-1.svg';
import { ReactComponent as SvgDecoratorBlob2 } from '../../images/svg-decorator-blob-3.svg';
import event1 from '../../images/advertisement3.jpg';
import event2 from '../../images/event2.jpg';
import event3 from '../../images/event3.jpg';

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ThreeColumn = tw.div`flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap`;
const Column = tw.div`mt-24 lg:w-1/3`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
// const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const Card = tw.div`lg:mx-4 xl:mx-8 max-w-sm flex flex-col h-full`;
const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`bg-cover bg-center h-80 lg:h-64 rounded rounded-b-none`,
]);

const Details = tw.div`p-6 rounded border-2 border-t-0 rounded-t-none border-dashed border-primary-100 flex-1 flex flex-col items-center text-center lg:block lg:text-left`;
// const MetaContainer = tw.div`flex items-center`;
// const Meta = styled.div`
//   ${tw`text-secondary-100 font-medium text-sm flex items-center leading-none mr-6 last:mr-0`}
//   svg {
//     ${tw`w-4 h-4 mr-1`}
//   }
// `;

const Title = tw.h5`mt-4 leading-snug font-bold text-lg`;
const Description = tw.p`mt-2 text-sm text-secondary-100`;
// const Link = styled(PrimaryButtonBase).attrs({ as: 'a' })`
//   ${tw`inline-block mt-4 text-sm font-semibold`}
// `;

const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`-z-10 absolute bottom-0 right-0 w-48 h-48 transform translate-x-40 -translate-y-8 opacity-25`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob2
)`-z-10 absolute top-0 left-0 w-48 h-48 transform -translate-x-32 translate-y-full opacity-25`;

export default ({
  subheading = '',
  heading = (
    <>
      Events and <span tw='text-primary-500'>Announcements.</span>
    </>
  ),
  // description = 'Some amazing blog posts that are written by even more amazing people.',
}) => {
  const blogPosts = [
    {
      imageSrc: event1,
      title: 'Annual Sports Day',
      description:
        'Join us on September 15th for an exciting day of athletic competitions and team spirit.',
      url: 'https://reddit.com',
    },
    {
      imageSrc: event2,
      author: 'Owais Khan',
      category: 'Advertising',
      title: 'Holiday Breaks',
      description:
        'Holiday Break: The school will be closed for the holiday season from December 20th to January 5th. Enjoy the festive season!',
      url: 'https://timerse.com',
    },
    {
      imageSrc: event3,
      author: 'Steve Schoger',
      category: '',
      title: 'Parent-Teacher Conferences',
      description:
        'Providing an opportunity to discuss your child’s progress with their teachers.',
      url: 'https://timerse.com',
    },
  ];
  return (
    <Container>
      <Content>
        <HeadingInfoContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <HeadingTitle>{heading}</HeadingTitle>
        </HeadingInfoContainer>
        <ThreeColumn>
          {blogPosts.map((post, index) => (
            <Column key={index}>
              <Card>
                <Image imageSrc={post.imageSrc} />
                <Details>
                  <Title>{post.title}</Title>
                  <Description>{post.description}</Description>
                </Details>
              </Card>
            </Column>
          ))}
        </ThreeColumn>
      </Content>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};
